import { API_BASE_URL } from "src/config/apiBase";
// src/pages/Dashboard.jsx
import React, { useEffect, useState, useCallback } from "react";
import { useSidebar } from "../../SidebarContext";
import Loader from "../Loader";
import UserDashboard from "./UserDashboard";
import Filter from "./Filter";
import DashboardCards from "./DashboardCards";
import axios from "axios";
import { toast } from "react-toastify";
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';
import SalesVsExpense from "./SalesVsExpense";
import TopCategory from "./TopCategory";
import OrderSummary from "./OrderSummary";
import CustomerDashboard from "./CustomerDashboard";
import ExpenseDashboard from "./ExpenseDashboard";
import ReceiptDashboard from "./ReceiptDashboard";
import InvoiceSummary from "./InvoiceDashboard";
import ActivityLog from "./ActivityLog";
import BottomButton from "./BottomButton";

const url = API_BASE_URL;

const Dashboard = () => {
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("Today");
    const [dailyRecords, setDailyRecords] = useState([]);
    const [activeTab, setActiveTab] = useState("Dashboard");

    const token = decryptToken("accessToken") || "";
    const user = getDecryptedUserFromCookie("gta_mainstateuser");

    const fetchAllData = useCallback(async () => {
        const token = decryptToken("accessToken") || "";
        const user = getDecryptedUserFromCookie("gta_mainstateuser");
        if (!user?.main_id) {
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const prodRes = await axios.get(`${url}/grouped-product/search-all-products/${user.main_id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const cleanedProducts = prodRes.data.map((p) => ({
                ...p,
                gallery: typeof p.gallery === "string" ? JSON.parse(p.gallery) : p.gallery,
                key_features: typeof p.key_features === "string" ? JSON.parse(p.key_features) : p.key_features,
                specifications: typeof p.specifications === "string" ? JSON.parse(p.specifications) : p.specifications,
            }));

            const orderRes = await fetch(`${url}/payment/adminorder`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            const orders = await orderRes.json();
            const parsedOrders = orders.map((o) => ({
                ...o,
                cart_products: typeof o.cart_products === "string" ? JSON.parse(o.cart_products) : o.cart_products,
                shipping_address: typeof o.shipping_address === "string" ? JSON.parse(o.shipping_address) : o.shipping_address,
                billing_address: typeof o.billing_address === "string" ? JSON.parse(o.billing_address) : o.billing_address,
            }));


            const custRes = await fetch(`${url}/api/customer/all/${user.main_id}`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            const customers = await custRes.json();
            const parsedCustomers = customers.map((c) => ({
                ...c,
                billingAddress: c.billingAddress ? JSON.parse(c.billingAddress) : {},
                shippingAddress: c.shippingAddress ? JSON.parse(c.shippingAddress) : {},
                contact: c.contact ? JSON.parse(c.contact) : [],
            }));

            const expRes = await fetch(`${url}/api/expenses/all/${user.main_id}`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            const expenses = await expRes.json();

            const recRes = await fetch(`${url}/receipt/${user.main_id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const receipts = await recRes.json();

            const invRes = await fetch(`${url}/newinvoice/all/${user.main_id}`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            const invoices = await invRes.json();

            const dayMap = new Map(); // key = "YYYY-MM-DD"

            const addToDay = (dateStr, key, value) => {
                if (!dayMap.has(dateStr)) {
                    dayMap.set(dateStr, {
                        date: dateStr,
                        products: 0,
                        orders: 0,
                        customers: 0,
                        sales: 0,
                        expenses: 0,
                        receipts: 0,
                        invoices: 0,
                    });
                }
                const rec = dayMap.get(dateStr);
                rec[key] += Number(value) || 0;
            };

            console.log(dayMap)
            cleanedProducts.forEach((p) => {
                const date = p.createdAt?.slice(0, 10) || new Date().toISOString().slice(0, 10);
                addToDay(date, "products", 1);
            });

            parsedOrders.forEach((o) => {
                // Use updatedAt if created_at is not consistent
                const date =
                    o.createdAt?.slice(0, 10) ||
                    o.updatedAt?.slice(0, 10) ||
                    new Date().toISOString().slice(0, 10);

                // Count every order
                addToDay(date, "orders", 1);

                // Add to total sales only if status is Delivered
                if (o.orderStatus?.toLowerCase() === "delivered") {
                    const salesAmount = Number(o.amountafterdiscount) || 0;
                    addToDay(date, "sales", salesAmount);
                }
            });

            parsedCustomers.forEach((c) => {
                const date =
                    c.createdAt?.slice(0, 10) || new Date().toISOString().slice(0, 10);
                addToDay(date, "customers", 1);
            });



            expenses.forEach((e) => {
                const date = e.createdAt?.slice(0, 10) || new Date().toISOString().slice(0, 10);
                addToDay(date, "expenses", e.amount || 0);
            });

            receipts.forEach((r) => {
                const date = r.createdAt?.slice(0, 10) || new Date().toISOString().slice(0, 10);
                addToDay(date, "receipts", r.amount || 0);
            });


            invoices.forEach((i) => {
                const date = i.createdAt?.slice(0, 10) || new Date().toISOString().slice(0, 10);
                addToDay(date, "invoices", 1);

            });

            console.log(expenses, receipts, invoices,cleanedProducts)

            const records = Array.from(dayMap.values())
                .sort((a, b) => b.date.localeCompare(a.date));

            setDailyRecords(records);
        } catch (err) {
            console.error("Dashboard data fetch error:", err);
            toast.error("Failed to load dashboard data");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        void fetchAllData().catch((err) => {
            console.error("Dashboard data fetch error:", err);
            toast.error("Failed to load dashboard data");
            setLoading(false);
        });
    }, [fetchAllData]);

    const aggregate = (period) => {
        const now = new Date();
        const todayStr = now.toISOString().slice(0, 10);
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        const yesterdayStr = yesterday.toISOString().slice(0, 10);

        let days = [];

        switch (period) {
            case "Today":
                days = dailyRecords.filter((d) => d.date === todayStr);
                break;
            case "Yesterday":
                days = dailyRecords.filter((d) => d.date === yesterdayStr);
                break;
            case "Weekly": {
                const weekStart = new Date(now);
                weekStart.setDate(now.getDate() - 7); // last 7 days
                days = dailyRecords.filter((d) => new Date(d.date) >= weekStart);
                break;
            }

            case "Monthly": {
                const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
                days = dailyRecords.filter((d) => {
                    const dDate = new Date(d.date);
                    return (
                        dDate.getFullYear() === now.getFullYear() &&
                        dDate.getMonth() === now.getMonth()
                    );
                });

                break;
            }
            default:
                // custom range
                if (period?.type === "Custom Date") {
                    const { from, to } = period;
                    days = dailyRecords.filter((d) => d.date >= from && d.date <= to);
                } else {
                    days = dailyRecords;
                }
        }

        const sum = (key) => days.reduce((acc, cur) => acc + cur[key], 0);

        return {
            products: sum("products"),
            orders: sum("orders"),
            customers: sum("customers"),
            sales: sum("sales"),
            expenses: sum("expenses"),
            receipts: sum("receipts"),
            invoices: sum("invoices"),
        };
    };

    const current = aggregate(filter);


    const previous = (() => {
        if (filter === "Today") return aggregate("Yesterday");
        if (filter === "Yesterday") {
            const twoDaysAgo = new Date();
            twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
            const twoDaysAgoStr = twoDaysAgo.toISOString().slice(0, 10);
            return aggregate({ type: "Custom Date", from: twoDaysAgoStr, to: twoDaysAgoStr });
        }

        const prevMonth = new Date();
        prevMonth.setMonth(prevMonth.getMonth() - 1);
        const monthStart = new Date(prevMonth.getFullYear(), prevMonth.getMonth(), 1);
        const monthEnd = new Date(prevMonth.getFullYear(), prevMonth.getMonth() + 1, 0);
        return aggregate({
            type: "Custom Date",
            from: monthStart.toISOString().slice(0, 10),
            to: monthEnd.toISOString().slice(0, 10),
        });
    })();



    if (loading) return <Loader />;


    return (
        <div className="w-full min-w-0 space-y-4">
            <div className="flex flex-wrap justify-between items-center gap-2 mb-1">
                {/* Top Tabs */}
                <div className="flex flex-wrap gap-2 sm:gap-3">
                    {["Dashboard", "Activity Log"].map((tab) => (
                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={`px-3 sm:px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap
        ${activeTab === tab
                                    ? "bg-blue-600 text-white shadow-md"
                                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                                }
      `}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
                <div className="hidden md:inline-flex shrink-0">
                    <UserDashboard />
                </div>
            </div>

            {/* Tab Content */}
            {activeTab === "Dashboard" ? (
                <>
                    <Filter value={filter} onChange={setFilter} />
                    <DashboardCards current={current} previous={previous} />

                    <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 mt-6 items-stretch">
                        <div className="xl:col-span-2 w-full min-w-0 p-2 pt-3 border border-gray-200 rounded-lg">
                            <SalesVsExpense filter={filter} dailyRecords={dailyRecords} />
                        </div>
                        <div className="xl:col-span-1 w-full min-w-0 p-2 pt-3 border border-gray-200 rounded-lg">
                            <OrderSummary filter={filter} />
                        </div>
                    </div>

                    <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 mt-6 items-stretch">
                        <div className="xl:col-span-1 w-full min-w-0 p-2 pt-3 border border-gray-200 rounded-lg">
                            <TopCategory />
                        </div>
                        <div className="xl:col-span-2 w-full min-w-0 p-2 pt-3 border border-gray-200 rounded-lg">
                            <CustomerDashboard filter={filter} dailyRecords={dailyRecords} />
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-5 mt-5">
                        <div className="w-full min-w-0 p-2 pt-3 border border-gray-200 rounded-lg">
                            <ExpenseDashboard filter={filter} url={url} user={user} token={token} />
                        </div>
                        <div className="w-full min-w-0 p-2 pt-3 border border-gray-200 rounded-lg">
                            <ReceiptDashboard filter={filter} url={url} user={user} token={token} />
                        </div>
                        <div className="w-full min-w-0 p-2 pt-3 border border-gray-200 rounded-lg">
                            <InvoiceSummary filter={filter} />
                        </div>
                    </div>
                    <BottomButton />
                </>
            ) : (
                <>
                    <ActivityLog />
                </>
            )}
        </div>
    );
};

export default Dashboard;